import { useEffect, useState } from "react";
import { Heart, Home, Menu, MessageCircle, Search, ShoppingBag, X } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";
import { brand } from "@kineslima/config";
import { Brand } from "./Brand";

const nav = [
  ["Inicio", "/"],
  ["Catálogo", "/catalogo"],
  ["Colecciones", "/colecciones"],
  ["Nosotros", "/nosotros"],
  ["Contacto", "/contacto"],
] as const;

export function PublicLayout() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 18);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0b0710] text-white">
      <header className={`site-header ${scrolled ? "is-scrolled" : ""}`}>
        <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 lg:px-8">
          <Brand />
          <nav className="hidden items-center gap-7 lg:flex" aria-label="Navegación principal">
            {nav.map(([label, to]) => (
              <NavLink key={to} to={to} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden items-center gap-2 lg:flex">
            <NavLink to="/catalogo" className="icon-button" aria-label="Buscar"><Search size={19} /></NavLink>
            <button className="icon-button" aria-label="Favoritos"><Heart size={19} /><span className="counter">2</span></button>
            <NavLink to="/catalogo" className="primary-button !min-h-10"><ShoppingBag size={17} /> Comprar</NavLink>
          </div>
          <button onClick={() => setOpen((value) => !value)} className="icon-button lg:hidden" aria-label={open ? "Cerrar menú" : "Abrir menú"}>
            {open ? <X /> : <Menu />}
          </button>
        </div>
        {open && (
          <div className="mobile-menu lg:hidden">
            {nav.map(([label, to]) => <NavLink key={to} to={to} onClick={() => setOpen(false)}>{label}</NavLink>)}
          </div>
        )}
      </header>

      <main><Outlet /></main>

      <footer className="border-t border-white/8 bg-[#08050b] px-5 pb-28 pt-16 md:pb-10 lg:px-8">
        <div className="mx-auto grid max-w-[1380px] gap-10 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1.1fr]">
          <div><Brand /><p className="mt-5 max-w-xs text-sm leading-6 text-white/55">Lencería seleccionada para sentirte cómoda, segura y auténtica. Atención privada y entregas discretas en Lima.</p></div>
          <div><p className="footer-title">Explora</p>{nav.slice(0, 3).map(([l,t]) => <NavLink className="footer-link" key={t} to={t}>{l}</NavLink>)}</div>
          <div><p className="footer-title">Ayuda</p><NavLink className="footer-link" to="/contacto">Guía de tallas</NavLink><NavLink className="footer-link" to="/contacto">Cambios y envíos</NavLink><NavLink className="footer-link" to="/privacidad">Privacidad</NavLink></div>
          <div><p className="footer-title">Atención privada</p><p className="text-sm text-white/55">Lun–Sáb · 10:00 a 20:00</p><a className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-fuchsia-300" href={`https://wa.me/${brand.whatsapp}`} target="_blank" rel="noreferrer"><MessageCircle size={16} /> {brand.phone}</a><p className="mt-6 text-xs text-white/35">Contenido dirigido a personas mayores de 18 años.</p></div>
        </div>
        <div className="mx-auto mt-12 flex max-w-[1380px] flex-col gap-3 border-t border-white/8 pt-6 text-xs text-white/35 md:flex-row md:justify-between"><span>© 2026 KinesLima. Todos los derechos reservados.</span><span>Fotografía editorial con identidad protegida.</span></div>
      </footer>

      <nav className="bottom-nav lg:hidden" aria-label="Navegación móvil">
        <NavLink to="/"><Home /><span>Inicio</span></NavLink>
        <NavLink to="/catalogo"><Search /><span>Buscar</span></NavLink>
        <a className="whatsapp-main" href={`https://wa.me/${brand.whatsapp}`} target="_blank" rel="noreferrer"><MessageCircle /><span>Consultar</span></a>
        <NavLink to="/favoritos"><Heart /><span>Favoritos</span></NavLink>
        <button onClick={() => setOpen(true)}><Menu /><span>Menú</span></button>
      </nav>
    </div>
  );
}
